<template>
  <div>
    <HeadNav :title="headNavImg.title" :titleEn="headNavImg.profiles" :src="headNavImg.picture"></HeadNav>
    <div class="content">
      <el-row>
        <el-col
          :span="6"
          style="border-left:1px solid rgb(220,220,220);border-right:1px solid rgb(220,220,220);border-top:1px solid rgb(220,220,220);"
        >
          <ContentNav :List="list" title="设备维修" titleEn="Equipment Maintenance" @increase="init"></ContentNav>
        </el-col>
        <el-col :span="18" style="padding:0 50px;">
          <h3>{{headTitle}}</h3>
          <el-divider></el-divider>
          <div v-html="contentHtmlPC" v-loading="loading"></div>
        </el-col>
      </el-row>
    </div>
    <div class="contentMobile">
      <el-row>
        <el-col
          :span="24"
          style="border-left:1px solid rgb(220,220,220);border-right:1px solid rgb(220,220,220);border-top:1px solid rgb(220,220,220);"
        >
          <ContentNav :List="list" title="维保支援" titleEn="Equipment Maintenance" @increase="init"></ContentNav>
        </el-col>
        <el-col :span="24" style="margin:20px 0">
          <div v-html="contentHtmlMobile" class='mobileEditor'></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import HeadNav from "../components/head.vue";
import ContentNav from "../components/content.vue";
import { getNavTitle, getProduct,getTheme } from "../api/allApiRequest.js";
export default {
  name: "spareParts",
  data() {
    return {
      list: [],
      headTitle: "",
      loading: false,
      contentHtmlMobile: "",
      contentHtmlPC: "",
      headNavImg: {},
      value:0,
      activeId:''
    };
  },
  components: {
    HeadNav,
    ContentNav
  },
  mounted() {
    this.value = location.hash.split('?')[1] ? location.hash.split('?')[1].split('&')[0].split('=')[1] : 0
    this.activeId =  location.hash.split('?')[1] ? location.hash.split('?')[1].split('&')[1].split('=')[1] : 0
    this.getThemeHead();
    getNavTitle().then(res => {
      res.data.forEach(item => {
        item.title == "维保支援" ? (this.list = item.children) : "";
      });
       //默认拿到第一条数据显示处理
      if(this.list.length){
        this.defaultShowId = this.list[0].children[0].id;
        this.headTitle = this.list[0].children[0].title;
        getProduct({defaultTypeId:this.defaultShowId}).then(res=>{
          let data = res.data.records[0]
          if(data){
                this.contentHtmlPC = data.profiles
                this.contentHtmlMobile = data.detailsPhone
          }
          this.loading = false
        })
      }else{
        this.headTitle="暂无数据";
        this.contentHtmlPC = "暂无数据";
        this.contentHtmlMobile = "暂无数据";
      }
    });
  },
  methods: {
    init(e) {
      this.headTitle = e.title;
      this.loading = true;
      this.contentHtmlMobile = "暂无信息";
      this.contentHtmlPC = "暂无信息";
      getProduct({ defaultTypeId: e.id }).then(res => {
        let data = res.data.records[0];
        if (data) {
          this.contentHtmlPC = data.profiles;
          this.contentHtmlMobile = data.detailsPhone;
        }
        this.loading = false;
      });
    },
     //主题返现
    getThemeHead() {
      getTheme({
        themeType: this.value
      }).then(res => {
        this.headNavImg = res.data.records[0];
        res.data.records[0].picture =
          process.env.VUE_APP_WEB_URL + res.data.records[0].picture;
      });
    }
  }
};
</script>
<style scoped>
.content {
  margin: 50px auto;
  width: 1190px;
}
.contentMobile {
  display: none;
}
@media screen and (max-width: 750px) {
  .content {
    display: none;
  }
  .contentMobile {
    display: block;
    margin: 0 10px;
  }
}
</style>